import { useBranch } from "@/hooks/useBranch"
import { useMemo } from "react"
import { GLOBAL_STATE } from "@/constants"
import process from "next/dist/build/webpack/loaders/resolve-url-loader/lib/postcss"

export function useGetCurrentStateDetails(allStates = []) {
	const { selectedOption } = useBranch()

	const detailedCurrentState = useMemo(() => {
		return allStates.filter((state) => state.handle.toLowerCase() === selectedOption.toLowerCase())
	})

	return detailedCurrentState.length > 0 ? detailedCurrentState[0] : null
}

export function useGetProperEnvKey(takeGlobalAsBackup = false) {
	const { selectedOption } = useBranch()
	const key = process.env.NEXT_FORMSPREE_KEYS
	const parsedKey = JSON.parse(key)

	if (!parsedKey[selectedOption] && takeGlobalAsBackup) {
		return parsedKey[GLOBAL_STATE] || "blankkey"
	}

	return parsedKey[selectedOption] || "blankkey"
}
